let ctx: AudioContext | null = null;

function context(): AudioContext | null {
  try {
    ctx ??= new AudioContext();
    if (ctx.state === "suspended") ctx.resume().catch(() => {});
    return ctx;
  } catch {
    return null;
  }
}

let armed = false;

/**
 * Unlocks the shared context on the first pointerdown anywhere, so a
 * collaborator who never touches a timer still hears it (Safari, iOS).
 * One listener for every timer, removed once it fires.
 */
export function unlockChimeOnFirstPointer(): void {
  if (armed) return;
  armed = true;
  document.addEventListener("pointerdown", () => context(), {
    capture: true,
    once: true,
  });
}

export function playChime(): void {
  const audio = context();
  if (!audio) return;
  const tone = (freq: number, at: number, duration: number, gain: number) => {
    const osc = audio.createOscillator();
    const vol = audio.createGain();
    osc.connect(vol);
    vol.connect(audio.destination);
    osc.frequency.value = freq;
    vol.gain.setValueAtTime(gain, audio.currentTime + at);
    vol.gain.exponentialRampToValueAtTime(
      0.001,
      audio.currentTime + at + duration,
    );
    osc.start(audio.currentTime + at);
    osc.stop(audio.currentTime + at + duration);
  };
  tone(880, 0, 0.18, 0.4);
  tone(1100, 0.2, 0.18, 0.4);
  tone(1320, 0.4, 0.35, 0.5);
}
